import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { EstablishedPageRoutingModule } from './established-routing.module';
import { EstablishedPage } from './established.page';
import { TranslateModule } from '@ngx-translate/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ActivateDebitCardModule } from 'src/app/components/activate-debit-card/activate-debit-card.module';
import { TabsModule } from 'src/app/components/home-page/tabs/tabs.module';
import { CustomCurrencyPipeModule } from 'src/app/angular-wallet-base/pipes/customcurrency/customcurrency.module';
import { PrimeModule } from '../../prime/prime.module';
import { OnRamperComponent } from 'src/app/components/on-ramper/on-ramper.component';
import { AchAgreementModalModule } from '../../../components/ach-agreement-modal/ach-agreement-modal';
import { AgxTosComponent } from 'src/app/views/settings/agx-tos/agx-tos.component';
import { TosContractsModule } from 'src/app/components/tos-contracts/tos-contracts.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    NgApexchartsModule,
    TabsModule,
    TosContractsModule,
    ActivateDebitCardModule,
    EstablishedPageRoutingModule,
    CustomCurrencyPipeModule,
    PrimeModule,
    AchAgreementModalModule
  ],
  declarations: [OnRamperComponent, EstablishedPage, AgxTosComponent]
})
export class EstablishedPageModule {}
